var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareerTech7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_19142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.33341C0 4.09923 3.42688 0.666748 7.65414 0.666748H37.3876C41.6148 0.666748 45.0417 4.09923 45.0417 8.33341V39.0001C45.0417 43.2343 41.6148 46.6667 37.3876 46.6667H7.65414C3.42688 46.6667 0 43.2343 0 39.0001V8.33341Z",
    fill: "#0077B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7053 40.2005H38.4878V26.4989C38.4878 19.732 34.398 17.424 30.6135 17.424C27.114 17.424 24.7367 19.7523 24.0804 21.1161V18.0467H17.5576V40.2005H24.3401V28.1894C24.3401 24.9868 26.3129 23.4293 28.3254 23.4293C30.2291 23.4293 31.7053 24.5304 31.7053 28.1005V40.2005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.18164 10.9571C6.18164 13.2699 7.93231 14.9601 10.0918 14.9601C12.2517 14.9601 14.0024 13.2699 14.0024 10.9571C14.0024 8.64451 12.2517 6.95239 10.0918 6.95239C7.93231 6.95239 6.18164 8.64451 6.18164 10.9571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70117 40.1833H13.4834V18.0295H6.70117V40.1833Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_19142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(0 0.666748)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerTech7);
export default __webpack_public_path__ + "static/media/careerTech7.2b61810c822068ebdc49061e9c8627d1.svg";
export { ForwardRef as ReactComponent };